import React, { useState, useEffect, useContext } from "react";

import GlobalContext from "../GlobalContext";

import { fetchSecure } from "../utils/utils";
import "../index.css";
import SuperAppButton from "./SuperAppButton";

const RestoreConfig = (props) => {
  const superAppStyle = useContext(GlobalContext)["superAppStyle"];

  async function handleRestoreAdminConfig() {
    const response = await fetchSecure(
      "/api/copyObject/adminConfigBackup/adminConfig/" + props.user
    );
    const data = await response.json();

    if (data.success) {
      alert("Admin Config has been restored");
    } else {
      alert("Admin Config could NOT be restored");
    }
  }

  useEffect(() => {
    //console.log("IN HERE RestoreConfig useEffect - ");
    async function run() {
    }
    run();
  }, []);

  return (
    <div>
      <SuperAppButton
        className='primary-gradient-btn'
        onClick={handleRestoreAdminConfig}>
        {props.label}
      </SuperAppButton>
    </div>
  );
};

export default RestoreConfig;
